let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("425pi"), load("tLGOl")]).then(() => parcelRequire('anKEx'));